// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"placeholder___2nzVN"};